import { declareTheme } from "@component-library/themes"

export const useTheme = declareTheme({
  default: {
    text: 'text-sm text-neutral-950 font-medium'
  },
  editor: {
    text: 'text-xs text-neutral-500 font-normal'
  }
})